var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedXMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CBF20428-1E00-4886-9697-C42EDBF4FDAB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logins---Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Customer-Portal---Desktop---Logins---Find-My-Policy---Registration---Link-Expired",
    transform: "translate(-736.000000, -358.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(476.000000, 318.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tick",
    transform: "translate(260.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80,39.9995268 C80,62.0916285 62.0914167,80 40,80 C17.9085833,80 0,62.0916285 0,39.9995268 C0,17.9083715 17.9085833,0 40,0 C62.0914167,0 80,17.9083715 80,39.9995268",
    id: "Fill-114",
    fill: "#D43900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3797401,25.6202588 C55.2067533,26.4472706 55.2067533,27.7880941 54.3797401,28.6151059 L42.994,39.999 L54.3797415,51.3849026 C55.2067528,52.2119124 55.2067528,53.5526622 54.3797415,54.379672 C53.9661653,54.7932475 53.4242598,55 52.8822836,55 C52.3403074,55 51.7984019,54.7932475 51.3848962,54.3797426 L39.999,42.994 L28.6149887,54.3798118 C28.2014821,54.7932471 27.6595753,55 27.1175979,55 C26.5756204,55 26.0337136,54.7932471 25.620207,54.3797412 C24.7932643,53.5527294 24.7932643,52.2119765 25.620207,51.3849647 L37.005,40 L25.6202055,28.6150974 C24.7932648,27.7880876 24.7932648,26.4472672 25.6202055,25.6202574 C26.4472168,24.7932475 27.7880395,24.7932475 28.6150508,25.6202574 L40,37.005 L51.3849583,25.6202588 C52.211901,24.7932471 53.5527974,24.7932471 54.3797401,25.6202588 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedXMark);
export default __webpack_public_path__ + "static/media/RedXMark.abfa32ab1b9fe71271b2524da33d1bb8.svg";
export { ForwardRef as ReactComponent };